import { Chip, Link, Tooltip } from '@material-ui/core';
import { SaleIcon } from 'components/icons/sale';
import React from 'react';
import { AnimalTagsSimpleProps } from './animal-tags-simple-props';
import { showTagFromValue } from './animal-tags-utils';
import './animal-tags.scss';
import { Tag } from './tag';

export const AnimalTagsSimple: React.FC<AnimalTagsSimpleProps> = (props) => {
  const {
    tags,
    size = 'small',
    show = 'all',
    showIcon = 'none',
    showTooltip = true,
    showWebsite = false,
  } = props;

  /**
     * Returns the `SaleIcon` if the showIcon prop is set.
     * @param tag
     */
  const getIcon = (tag: Tag) => {
    if (showIcon === 'all' || showIcon === tag.type) {
      return <SaleIcon fontSize="small" />;
    }
    return <></>;
  };

  return (
    <div className="sg-animal-tags">
      {tags.map((tag) => (
        showTagFromValue(tag, show) && (
        <Tooltip
          placement="top"
          title={tag.label}
          key={tag.id}
          disableFocusListener={!showTooltip}
          disableHoverListener={!showTooltip}
          disableTouchListener={!showTooltip}
          PopperProps={{
            className: 'sg-animal-tags__tooltip',
          }}
        >
          <span className={`tag-container ${showTooltip ? 'tag-container--pointer' : ''}`}>
            {tag.type === 'primary' && (
            <Chip
              label={size === 'large' ? tag.label : tag.chip}
              size={size === 'large' ? 'medium' : 'small'}
              color="default"
              clickable={false}
              className="animal__tag animal__tag--primary"
              icon={getIcon(tag)}
            />
            )}
            {tag.type === 'secondary' && (
            <>
              <Chip
                label={tag.chip}
                size={size === 'large' ? 'medium' : 'small'}
                color="default"
                clickable={false}
                className="animal__tag"
              />
              {showWebsite && (
              <>
                {tag.website ? (
                  <Link
                    href={tag.website}
                    target="_blank"
                    rel="noopener"
                  >
                    {tag.label}
                  </Link>
                )
                  : (
                    <span className="tag__label">
                      {tag.label}
                    </span>
                  )}
              </>
              )}
            </>
            )}
          </span>
        </Tooltip>
        )
      ))}
    </div>
  );
};
